import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { ValidationErrorPrefix, ValidationErrorsResponse } from './validation-error.dto';
import { GlobalService } from '../global.service';
import { DocumentFieldEmitterService } from '../documentfield-emitter.service';
import { Field } from 'app/interfaces/fields';

@Injectable({
  providedIn: 'root'
})
export class ValidationHandlerService {
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    private globalService: GlobalService,
    private documentFieldEmitterService: DocumentFieldEmitterService,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  handleValidationErrors(errorResponse: ValidationErrorsResponse, isEditor: boolean = true, keyPrefix: ValidationErrorPrefix = ValidationErrorPrefix.FieldsData): void {
    if (!errorResponse?.errors) return;
    const regex = new RegExp(`${keyPrefix}\\.(\\d+)\\.value`);
    Object.entries(errorResponse.errors).forEach(([key, messages]) => {
      // Extract UUID from key
      const match = key.match(regex);
      const uuid = match ? match[1] : null;
      messages.forEach(msg => {
        this.globalService.toastrError(msg);
      });
      if (uuid || !isEditor) {
        if (isEditor) {
          // Highlight DOM element
          this.highlightInvalidField(uuid);
        }
      }
    });
  }

  private highlightInvalidField(uuid: string): void {
    const fieldData: Field = this.globalService.fields_data[uuid];
    const el = document.querySelector(`.drag-fields[uuid="${uuid}"]`) as HTMLElement | null;
    if (el) {
      this.renderer.addClass(el, 'field-invalid');
    }
    this.globalService.updateField(uuid, { field_invalid: 1 });
    this.documentFieldEmitterService.patchData({ uuid: uuid, value: ((fieldData?.value ?? '')), refresh: 1 });
  }

  resetFieldHighlight(uuid: string, emit:boolean = true): void {
    const fieldData: Field = this.globalService.fields_data[uuid];
    const el = document.querySelector(`.drag-fields[uuid="${uuid}"]`) as HTMLElement | null;
    if (el) {
      this.renderer.removeClass(el, 'field-invalid');
    }
    if(emit){
      this.globalService.updateField(uuid, { field_invalid: 0 });
      this.documentFieldEmitterService.patchData({ uuid: uuid, value: ((fieldData?.value ?? '')), refresh: 1 });
    }
  }

}
